export default "__VITE_ASSET__9d64a1ce__"